import { CalendarDate, isSameDay } from '@internationalized/date';

import range from '../../../../helpers/array/range';
import Button from '../../../Button/Button';
import Column from '../../../Column/Column';
import Columns from '../../../Columns/Columns';
import Stack from '../../../Stack/Stack';

export type DateValue = {
    label: string;
    value: CalendarDate;
    disabled?: boolean;
};

type PredefinedDatesCalendarProps = {
    dates: Array<DateValue>;
    value?: CalendarDate | null;
    onChange: (focusDate: CalendarDate) => void;
    columns?: number;
};

const PredefinedDatesCalendar = ({
    dates,
    value,
    onChange,
    columns = 3,
}: PredefinedDatesCalendarProps) => {
    const renderButton = (date: DateValue) => {
        return (
            <Button
                key={date.label}
                fullWidth
                disabled={date.disabled}
                variant={
                    value && isSameDay(value, date.value) ? 'brand' : 'white'
                }
                onClick={() => onChange(date.value)}
            >
                {date.label}
            </Button>
        );
    };

    return (
        <Columns gap="large">
            {range(1, columns).map((col) => (
                <Column key={col} width="1/3">
                    <Stack space="small">
                        {dates
                            .filter(
                                (date, index) => index % columns === col - 1
                            )
                            .map(renderButton)}
                    </Stack>
                </Column>
            ))}
        </Columns>
    );
};

export default PredefinedDatesCalendar;
